import Vue from 'vue'
import Vuex from 'vuex'

import { AESencrypt, AESdecrypt } from '@/plugins/aes/index.js'

Vue.use(Vuex)

console.log('vuex init')

// 尝试获取本地是否存在lifeData变量，第一次启动时不存在

const getLifeJsonData = (saveKey) => {
  let JonsData = null
  try {
    JonsData = localStorage.getItem(saveKey)
  } catch (error) {
    console.error('vuex getItem getLifeJsonData 1 ', error)
  }
  JonsData = JonsData ? AESdecrypt(JonsData) : 'null'
  let parseData = {}
  try {
    parseData = JSON.parse(JonsData)
  } catch (error) {
    console.error('vuex parse getLifeJsonData 2 ', error)
  }
  return parseData
}

const saveKey_isp = 'lifeData_isp'
let lifeData_isp = {}
lifeData_isp = getLifeJsonData(saveKey_isp)
const saveKey = 'lifeData'
let lifeData = {}
lifeData = getLifeJsonData(saveKey)

console.warn('vuex local lifeData_isp   ::', lifeData_isp)
console.warn('vuex local lifeData   ::', lifeData)
// 标记需要永久存储的变量，在每次启动时取出，在state中的变量名
const saveStateKeys_ISP = [
  // "vuex_isp_miniapp_to_isp_action"
]
const saveStateKeys = [
  // "vuex_topWebKeysList",
  //  "vuex_topSearch"
]

const saveLifeData_ISP = function (key, value) {
  // 判断变量是否在存储数组中
  if (saveStateKeys_ISP.indexOf(key) != -1) {
    // 获取本地存储的saveKey_isp对象，将变量添加到对象中
    // let tmpLifeData = uni?.getStorageSync(saveKey_isp)
    let tmpLifeData = null
    tmpLifeData = getLifeJsonData(saveKey_isp);
    // 第一次启动时不存在，则放一个空对象
    (tmpLifeData = tmpLifeData || {}), (tmpLifeData[key] = value)
    // 将变量再次放回本地存储中
    // uni?.setStorageSync(saveKey_isp, tmpLifeData)
    try {
      const saveAESData = AESencrypt(JSON.stringify(tmpLifeData))
      console.log('saveAESData.length', saveAESData.length)
      localStorage.setItem(saveKey_isp, saveAESData)
    } catch (error) {
      console.error('localStorage setItem tmpLifeData_isp', error)
    }
  }
}
const saveLifeData = function (key, value) {
  // 判断变量是否在存储数组中
  if (saveStateKeys.indexOf(key) != -1) {
    // 获取本地存储的saveKey对象，将变量添加到对象中
    // let tmpLifeData = uni?.getStorageSync(saveKey)
    let tmpLifeData = null
    tmpLifeData = getLifeJsonData(saveKey);
    // 第一次启动时不存在，则放一个空对象
    (tmpLifeData = tmpLifeData || {}), (tmpLifeData[key] = value)
    // 将变量再次放回本地存储中
    // uni?.setStorageSync(saveKey, tmpLifeData)
    try {
      const saveAESData = AESencrypt(JSON.stringify(tmpLifeData))
      console.log('saveAESData.length', saveAESData.length)
      localStorage.setItem(saveKey, saveAESData)
    } catch (error) {
      console.error('localStorage setItem tmpLifeData', error)
    }
  }
}
const state = {
  // 如果上面从本地获取的lifeData对象下有对应的属性，就赋值给state中对应的变量
  // 加上vuex_isp_前缀，是防止变量名冲突，也让人一目了然
  // vuex_isp_user: lifeData_isp.vuex_isp_user ? lifeData_isp.vuex_isp_user : {
  // 	name: 'hx'
  // },

  // 如果vuex_isp_version无需保存到本地永久存储，无需lifeData.vuex_isp_version方式

  // app版本

  // vuex_isp
  ...lifeData_isp,
  // vuex_isp_storageServerUrl:
  //   lifeData_isp?.vuex_isp_storageServerUrl || "https://isp.sahcqmu.com:10100", // 需要提前定义

  vuex_version: process.env.VUE_APP_VERSION,
  vuex_version_time: process.env.VUE_APP_VERSION_TIME,
  vuex_version_time_stamp: process.env.VUE_APP_VERSION_TIMESTAMP,
  vuex_version_hasNew: false,

  vuex_sysId: '',
  vuex_dev_mode_open: false,

  // vant
  vuex_vant_toast: null,

  vuex_app_phone: '',
  // vuex_app_phone: "18682128689",
  // vuex_app_password: "111111",
  vuex_app_token: '',
  vuex_app_user_info: {
    global_status: '',
    silence_url: '',
    talk_url: '',
    tts_template_id: '',
    video_end_tm: 0,
    video_name: '1705137984-18811111113.png',
    video_start_tm: 0,
    video_status: 'finished',
    video_waiting_time: 0
  },
  vuex_app_video_info: {},
  vuex_baidu_asr_token: '',
  vuex_aliyun_tts_token: '',
  vuex_app_project_data: null,
  vuex_app_prompt_info: {},
  vuex_cardInfo: {},
  vuex_userVideoInfo: [],
  visitList: localStorage.getItem('visitList') ? JSON.parse(localStorage.getItem('visitList')) : [],
  showQRCodeDialogEnd: localStorage.getItem('showQRCodeDialogEnd') ? JSON.parse(localStorage.getItem('showQRCodeDialogEnd')) : false, // 是否展示过群二维码弹窗
  weiXinMark: false,
  miniProgramMark: false,
  networkStr: 'networkStr',
  chatHistory: [],
  visitUserName: localStorage.getItem('visitUserName') ? localStorage.getItem('visitUserName'): '',
  appletInfo: {
    user_token: '',
    native: '',
    identity: '', // native 和 identity字段名不能复用 必须要区分开
    follow_state: false,
    user_name: '',
    is_new: 0,
    curr_time: 1714966883966,
    shop_token:'',
    isCare: false,
    wxPhone: '',
    code: ''
  },
  mall_shop_id: '',
  // TTS新版声音克隆鉴权
  ttsInfo: {
    accessToken: '',
    group_id: ''
  },
  loginMiniDialog: false, // 全局登录小程序弹窗
  jumpLoginMessage: '您需要登录后使用该功能，是否通过小程序授权登录？'
}

// 开发环境，内网
// if (process.env.NODE_ENV === 'development') {
// 	state.vuex_isp_storageServerUrl = '' //内网去除前缀
// }

console.warn('vuex', state)

const store = new Vuex.Store({
  state,
  mutations: {
    $tStore_ISP (state, payload) {
      // 判断是否多层调用，state中为对象存在的情况，例如user.info.score = 1
      const nameArr = payload.name.split('.')
      let saveKey = ''
      const len = nameArr.length
      if (len >= 2) {
        let obj = state[nameArr[0]]
        for (let i = 1; i < len - 1; i++) {
          obj = obj[nameArr[i]]
        }
        obj[nameArr[len - 1]] = payload.value
        saveKey = nameArr[0]
      } else {
        // 单层级变量
        state[payload.name] = payload.value
        saveKey = payload.name
      }
      // 保存变量到本地中
      saveLifeData_ISP(saveKey, state[saveKey])
    },
    $tStore (state, payload) {
      // 判断是否多层调用，state中为对象存在的情况，例如user.info.score = 1
      const nameArr = payload.name.split('.')
      let saveKey = ''
      const len = nameArr.length
      if (len >= 2) {
        let obj = state[nameArr[0]]
        for (let i = 1; i < len - 1; i++) {
          obj = obj[nameArr[i]]
        }
        obj[nameArr[len - 1]] = payload.value
        saveKey = nameArr[0]
      } else {
        // 单层级变量
        state[payload.name] = payload.value
        saveKey = payload.name
      }
      // 保存变量到本地中
      saveLifeData(saveKey, state[saveKey])
    },
    showVuxToastLoading (state, config) {
      if (state.vuex_vant_toast) {
        state.vuex_vant_toast?.clear?.()
      }
      state.vuex_vant_toast = null

      state.vuex_vant_toast = Vue.prototype.$myToast({
        type: 'loading',
        message: '请稍等',
        overlay: true,
        forbidClick: true,
        duration: 0,
        ...config
      })
    },
    clearVuxToastLoading (state) {
      if (state.vuex_vant_toast) {
        state.vuex_vant_toast?.clear?.()
      }
      state.vuex_vant_toast = null
    },
    updateVuex_aliyun_tts_token (state, value) {
      state.vuex_aliyun_tts_token = value
    },
    updateVisit(state, value) {
      // 获取当前时间戳
      const currentTimestamp = new Date().getTime();
      let timestamp = {timestamp: currentTimestamp}
      // 判断是否超过1天 与第0个数组的时间戳相比较
      if (state.visitList.length > 0){
        let time0 = state.visitList[0].timestamp
        // 判断是否一天内  超过3天重置清空
        if (Math.abs(currentTimestamp - time0) > 24 * 1000 * 60 * 60) {
          state.visitList = []
        }
      }
      state.visitList.push(timestamp)
      localStorage.setItem('visitList',  JSON.stringify(state.visitList))
    },
    updateShowQRCodeDialogEnd(state, value) {
      state.showQRCodeDialogEnd = value
      localStorage.setItem('showQRCodeDialogEnd', JSON.stringify(value))
    },

    updateWeiXinMark(state, value) {
      state.weiXinMark = value
    },
    updateHistory(state, value) {
      state.chatHistory = value
    },
    addHistory(state, value) {
      state.chatHistory.push(value)
    },
    updateVisitUserName(state, value) {
      state.visitUserName = value
      localStorage.setItem('visitUserName', value)
    },
    updateIsCareStatus(state, value) {
      state.appletInfo.isCare = value
    },
    updateMiniProgramMark(state, value) {
      state.miniProgramMark = value
    },
    updateShopId(state, value) {
      state.mall_shop_id = value
    }
  },
  actions: {}
})

export default store
